import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AppSettingsService {
  public path = '../../assets/configuration.json';

  constructor(private http: HttpClient) {}

  getConfigFromFile(): Observable<any> {
    return this.http.get(this.path);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/app-settings.service.ts